import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import MuiButton from "@material-ui/core/Button";

import { translate as translateHOC } from "jazasoft";

import { isPromise } from "../utils/helpers";

const useStyles = makeStyles({
  root: {
    display: "inline-block"
  },
  width: {
    width: 400
  }
});

const ConfirmDialog = props => {
  const { labelConfirm, labelCancel, onConfirm, open, onCancel, confirmTitle, confirmMessage, translate, ...rest } =
    props;
  const classes = useStyles();

  const handleClose = async event => {
    if (isPromise(onCancel)) {
      await onCancel(event);
    } else if (typeof onCancel === "function") {
      onCancel(event);
    }
  };

  const handleSubmit = async event => {
    if (isPromise(onConfirm)) {
      await onConfirm(event);
    } else if (typeof onConfirm === "function") {
      onConfirm(event);
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} {...rest}>
      <DialogTitle className={classes.width}>{confirmTitle}</DialogTitle>
      {confirmMessage && (
        <DialogContent>
          <DialogContentText>{confirmMessage}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <MuiButton onClick={handleClose} color="primary" variant="outlined">
          {translate(labelCancel, {_: labelCancel})}
        </MuiButton>
        <MuiButton onClick={handleSubmit} color="primary" variant="contained" autoFocus>
          {translate(labelConfirm, {_: labelConfirm})}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  labelConfirm: PropTypes.string, // String or i18nCode
  labelCancel: PropTypes.string, // String or i18nCode
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func
};

ConfirmDialog.defaultProps = {
  labelConfirm: "js.action.delete",
  labelCancel: "js.action.cancel",
  confirmTitle: "Delete Record?",
  confirmMessage: "",
  open: false
};

export default translateHOC(ConfirmDialog);
